import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../utils/ua'
import './style.less';

class Privacy4Page extends Component {
    constructor(props){
        super(props);
        this.state = {};
    }
    render(){
        return(
            <DocumentTitle title={'VR课程项目免责协议'}>
                <div className={`container privacyrules ${UA.mobileClient?'':'pc'}`}>
<h4>VR课程项目免责协议</h4><br/>
<p>参与者在此明确承认将自行承担参加“VR大开眼界”课程中各种环节所可能存在的一切风险。 </p><br/>
<p>1、我已认真阅读安全须知，并将严格遵循其所述规则操作：</p>
<p>1）孩子在使用VR眼镜时需必须有成人在身边陪伴；</p>
<p>2）不能把VR眼镜正对太阳或暴露在阳光直射下；</p>
<p>3）每次连续使用VR眼镜的时间不要超过15分钟</p>
<p>4）如有头晕、眼疲劳等不适反应，请立即停止使用；</p>
<p>5）在坐着时使用眼镜，避免站立、活动时使用；</p>
<p>6）使用VR眼镜时要经常停下来休息一会；</p>
<p>2、我已了解并同意遵守VR课程所采用的形式并愿意遵循；我已知道“VR大开眼界”是由诸多VR场景及互动组成，在佩带VR眼镜体验课程时存在一定的运动风险。游戏中如碰撞、踩踏、物品污损等任何问题要自行处理。</p>
<p>我同意在课程体验前检查附近上课环境、设施、设备，如果我发现存在任何不安全因素，将及时进行相应处理。</p>
         <p>3、我承诺在上课时会注意人身安全。若在课程体验时因为自身原因，导致摔跤、跌倒、磕碰等造成伤害的，课程方不负任何责任。</p>       
         <p>4、我明白残疾人、孕妇等特殊人群以及醉酒或身患心脏病、高血压、糖尿病、习惯性脱臼、癫痫、骨质疏松等不适宜本项活动的疾病禁止进行体验。</p>       
        <p>5、我明白并接受若因我的不当操作，造成设备损坏，或造成本人或他人生命健康安全，由我本人承担一切后果，课程方不承担一切责任。</p>      
        <p>6、我明白未满十六周岁需监护人确认同意参加，十二周岁以下的，需由监护人陪同，未成年人体验课程时产生的任何问题由监护人承担，课程方不承担一切责任。</p>    
             <p>7、我明白已满五十五周岁的老人不适宜参加本项目活动，如本人坚持自愿参加，过程中造成的任何损害，课程方将不承担任何责任。</p>   
                
        
                </div>
            </DocumentTitle>
        )
    }
}

export default Privacy4Page;


// WEBPACK FOOTER //
// ./src/components/privacyPage/privacy4Page.jsx